import { Menu } from './Menu';
// import { HelpButtonModal } from "./index";



import { LoadingPageData } from '../classes/LoadingPageData';

import { useState, useEffect } from 'react';

// Components

// import Header from './Components-AppPage/Header';

// -- Redux ----------------------------------------------

import { useDispatch, useSelector } from 'react-redux';

// Dispatchers

import {
	updateAppNameState,
} from '../store/dataStateReducers';

import {
	setAppPage
} from '../store/appStateReducers';

// Selectors
import { 
	getDataById
} from '../store/dataStateReducers';

import {
	getSearchParamsData
} from "../store/appStateReducers";
 

import { CompHTML } from "./widgets/index";

// ----------------------------------------------------------

export const SelectAppPage = (props) => {

	const dispatch = useDispatch();
	
	const login = useSelector( (state) => getDataById(state, "login") );
	const {
		// uid,
		// name_uid,
		apps_js
	} = login.data_js;

	// Selectors
	const search_params_js = useSelector( (state) => getSearchParamsData(state) );

	// Hooks
	const [app_data_js, setAppData] = useState(null);

	const [select_step_s, setSelectStep] = useState("awaiting: any selection");
	// - awaiting: any selection
	// 
	//   This is the initial state.
	// 
	//   It is in effect either while checking the search_params_js redux state
	//   or waiting for the user to click an app.
	//   
	//   But, if search_params_js is null, then select_step_s is set to 'awaiting: user selection'
	//
	// - loading: search params selection - app and uniq
	//
	//   select_step_s is set to this by the hook function, and indicates that get parameters
	//   are being used to direct the app to a particular activity based on the 'a' and 'u' parameters
	//   (e.g., por112, por112-cap1-4)
	//
	//   If it is successful, the page will be direct to the activity. If not, select_step_s
	//   is set to 'awaiting: user selection'
	//   
	// - awaiting: user selection
	//   
	//   if there are no get parameters (search_params_js is null) this 
	//   state just indicates that the component is waiting for waits for the user to click a possible app
	// 
	// - clicked: app selection
	//
	//   this gets set when the user clicks one of the apps on the page
	//   
	//   It causes the app to load the activities associated with a particular app (e.g., por112)
	//   While attempting to load it, select_step_s is set to 'loading: user app selection'
	//   
	// - loading: user app selection
	//
	//   This is set by the hook function, and indicates that an app was selected by the user.
	// 
	//   If it is successful, the page will be direct to the app and its activities. If not, select_step_s
	//   is set to 'awaiting: user selection'
	//   

	
	
	useEffect( () => {
		if (search_params_js !== null) {

			dispatch( updateAppNameState({
				app:search_params_js.a,
				name_app:apps_js[search_params_js.a]
			}));

			const loadingPageData = new LoadingPageData("activityPage");
			loadingPageData.setDataIdPhpScriptPair(
				'activity_data',
				'php/activity_get.php',
				{
					app: search_params_js.a,
					uniq: search_params_js.u
				}
				);
			const loadingPageDataProps = loadingPageData.getData().data;

			dispatch( 
				setAppPage(
					{ 	page: "loadingPage",
						props: loadingPageDataProps
					}
				)
			);

			setSelectStep("loading: search params selection - app and uniq");

		} else {

			setSelectStep("awaiting: user selection");

		}

	},[
		select_step_s,
		search_params_js,
		apps_js,
		dispatch
	] );

	useEffect( () => {
		if ( 
			select_step_s === "clicked: app selection" &&
			app_data_js !== null		
		) {

			dispatch( updateAppNameState(app_data_js));

			const loadingPageData = new LoadingPageData("appPage");
			loadingPageData.setDataIdPhpScriptPair('app_data','php/app_data_get.php');
			loadingPageData.setDataIdPhpScriptPair('uid_data','php/uid_data_get.php');

			const loadingPageDataResults = loadingPageData.getData();

			if ( loadingPageDataResults.result ) {
				dispatch( setAppPage(
					{
						page: "loadingPage",
						props: loadingPageDataResults.data
					})
				);

				setSelectStep("loading: user app selection");
				
			} else {
				console.log( "Err with loadingPageData " );
				setAppData(null);
				setSelectStep("awaiting: any selection");	
			}

			setAppData(null);
			setSelectStep("awaiting: any selection");	
	
		} else {

			setSelectStep("awaiting: user selection");

		}
	},
		[
			select_step_s,
			app_data_js,
			dispatch
		]
	);


	const handleClick = (event) => {
		const button_elem = event.target.parentElement;
		const js = {
			app: button_elem.getAttribute('data-app'),
			name_app: button_elem.getAttribute('data-name-app')
		};
		setAppData(js);
		setSelectStep("clicked: app selection");
	}


	const app_jsx = Object.keys(apps_js).map((e,index) => {
		return(
			<div key={index}>
				<button type="button" className="btn btn-link" onClick={handleClick} data-app={e} data-name-app={apps_js[e]} ><CompHTML html={apps_js[e]} /></button>
			</div>
		);
	});

	const jsx = (
		<div
			style={{
				marginBottom:20,
				paddingBottom: 200
			}}
		>
			{/* <p><b>{name_uid} ({uid})</b></p> */}
			<p>Choose the course you would like to work with:</p>
			<div>
				{app_jsx}
			</div>
		</div>
	);

	return (
		<>
			<Menu items={['logOut']} />
			<div>{jsx}</div>
		</>
	);
}